import styles from './FJFavorite.module.less';
import FJHeader from './FJHeader.jsx';
import FJLocalStore from '../../../../store/FJLocalStore.js';
import FJFavoriteEmptyBase64 from '../../../../assets/base64/favorite-empty.js';
import FJVerticalScroller from '../../../../common/components/FJScroller/FJVerticalScroller.jsx';
import FJVoiceItemContainer from '../container/FJVoiceItemContainer.jsx';
import FJConstant from '../../../../constants/FJConstant.js';
import FJOppsIcon from '../../../../assets/svg/oops.svg?react';
import FJButton from '../../../../common/components/FJButton/FJButton.jsx';
import FJAutoLoading from '../../../../common/components/FJLoading/FJAutoLoading.jsx';
import PropTypes from 'prop-types';
import { useState, useRef, useEffect } from 'react';
import FJLoading from '../../../../common/components/FJLoading/FJLoading.jsx';

const FJFavorite = props => {
    const { list, onUse, loadingStatus, onRetry } = props;

    const isLoadingRef = useRef(false);
    const [stateMaxCount, setStateMaxCount] = useState(30);

    useEffect(() => {
        isLoadingRef.current = false;
    }, [stateMaxCount]);

    useEffect(() => {
        setStateMaxCount(30);
    }, [list.length]);
    const _onTotalScroll = () => {
        if (isLoadingRef.current) return;

        if (stateMaxCount < list.length) {
            isLoadingRef.current = true;
            setStateMaxCount(stateMaxCount + 30);
        }
    };

    return (
        <div className={styles.box}>
            <FJHeader title={FJLocalStore._('favorites')} />
            <div className={styles.content_box}>
                {loadingStatus === FJConstant.LOADING && (
                    <div className={styles.state_box}>
                        <FJAutoLoading shown strokeColor='#9FA2AF' />
                    </div>
                )}
                {list.length === 0 && loadingStatus === FJConstant.ERROR && (
                    <div className={styles.state_box}>
                        <FJOppsIcon />
                        <div className={styles.retry_desc}>{FJLocalStore._('unknown-error-please-try-again')}</div>
                        <FJButton text='retry' className={styles.retry_btn} onClick={onRetry} />
                    </div>
                )}
                {list.length === 0 && loadingStatus === FJConstant.SUCCESS && (
                    <div className={styles.state_box}>
                        <img src={FJFavoriteEmptyBase64} alt='' />
                        <div className={styles.empty_desc}>{FJLocalStore._('no-favorites-yet')}</div>
                    </div>
                )}
                {list.length > 0 && loadingStatus === FJConstant.SUCCESS ? (
                    <FJVerticalScroller className={styles.scroll_box} onTotalScroll={_onTotalScroll}>
                        <div className={styles.content}>
                            {list.slice(0, stateMaxCount).map(item => {
                                return (
                                    <FJVoiceItemContainer
                                        info={item}
                                        key={item.value}
                                        isFavorite={true}
                                        onUse={info => {
                                            onUse(info, { fromType: item.type || FJConstant.MICROSOFT });
                                        }}

                                        fromType={item.type || FJConstant.MICROSOFT}
                                    />
                                );
                            })}
                            <div className={styles.bottom}>
                                {stateMaxCount >= list.length ? (
                                    <div className={styles.end}>{FJLocalStore._('scroll-end-tip')}</div>
                                ) : (
                                    <FJLoading strokeColor='#a8acbc' />
                                )}
                            </div>
                        </div>
                    </FJVerticalScroller>
                ) : null}
            </div>
        </div>
    );
};

FJFavorite.propTypes = {
    list: PropTypes.array,
    onUse: PropTypes.func,
    loadingStatus: PropTypes.string,
    onRetry: PropTypes.func,
};
export default FJFavorite;
